import PersonIcon from '@mui/icons-material/Person'
import { DeleteConfirmPopover } from '../shared'

interface ContactsPopoverProps {
  id?: string
  open: boolean
  anchorEl?: HTMLElement | null
  onClose: () => void
  handleConfirmDelete: () => void
  selectedData: any
}

const ContactsPopover = ({
  id,
  open,
  anchorEl,
  onClose,
  handleConfirmDelete,
  selectedData,
}: ContactsPopoverProps) => {
  return (
    <DeleteConfirmPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      onConfirm={handleConfirmDelete}
      entityName="Contact"
      entityIcon={<PersonIcon sx={{ fontSize: 35, color: 'rgb(255, 123, 187)' }} />}
      selectedData={selectedData}
      renderPreview={(contact) => contact?.name}
    />
  )
}

export default ContactsPopover
